import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {setCreateButton, setTitle} from "../actions/main";
import Loader from "../components/Loader";
import {EventsService} from "../services/EventsService";
import formater from "../helpers/formater";
import {CashService} from "../services/CashService";
import {Link} from "react-router-dom";
import {Calendar} from "primereact/calendar";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {Chart as PrimeChart} from 'primereact/chart';
import { Chart } from 'chart.js';
import {ArtistService} from "../services/ArtistService";
import {Dropdown} from "primereact/dropdown";
import {SelectButton} from "primereact/selectbutton";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import 'chartjs-plugin-datalabels';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ChartDataLabels)
Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

var dateOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
};

var dateMonthOptions = {
    year: 'numeric',
    month: 'numeric',
    // day: 'numeric'
};

var dateYearOptions = {
    year: 'numeric',
    // month: 'numeric',
    // day: 'numeric'
};


function AnaliticFull() {
    // Chart.chart.register(ChartDataLabels);
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [dohodData, setDohodData] = useState(false)
    const [daysData, setDaysData] = useState(false)
    const [daysRestData, setDaysRestData] = useState(false)
    const [monthData, setMonthData] = useState(false)
    const [monthRestData, setMonthRestData] = useState(false)
    const [date, setDate] = useState(() => {
        if (localStorage.getItem('analytic_date')) {
            return new Date(parseInt(localStorage.getItem('analytic_date')))
        } else {
            return new Date()
        }
    })
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const [events, setEvents] = useState(false)
    const [receipt, setReceipt] = useState(false)
    const [needRange, setNeedRange] = useState(true)

    let fd = new Date()
    fd.setMonth(fd.getMonth() - 1)

    console.log(fd)
    // setFirstDate()

    const [firstDate, setFirstDate] = useState([fd, new Date()])
    const [secondDate, setSecondDate] = useState(new Date())


    const [labels, setLabels] = useState([])
    const [artists, setArtists] = useState([])
    const [currentArtist, setCurrentArtist] = useState(false)
    const [dataType, setDataType] = useState('dohod')
    const [rangeType, setRangeType] = useState('month')

    const [firstSectionView, setFirstSectionVIew] = useState('bar')
    const [secondSectionView, setSecondSectionVIew] = useState('bar')

    const [firstEvents, setFirstEvents] = useState([])
    const [secondEvents, setSecondEvents] = useState([])


    const getDates = (startDate, stopDate) => {
        let dateArray = [];
        let currentDate = startDate;
        let hasDates = []

        if (rangeType === 'days') {
            while (currentDate <= stopDate) {
                dateArray.push(new Date(currentDate));
                currentDate = currentDate.addDays(1);
            }
        }
        if (rangeType === 'month') {
            while (currentDate <= stopDate) {
                if (hasDates.indexOf(currentDate.toLocaleString('ru', dateMonthOptions)) === -1) {
                    hasDates.push(currentDate.toLocaleString('ru', dateMonthOptions))
                    dateArray.push(new Date(currentDate))
                }
                currentDate = currentDate.addDays(1)
            }
        }
        if (rangeType === 'year') {
            while (currentDate <= stopDate) {
                if (hasDates.indexOf(currentDate.toLocaleString('ru', dateYearOptions)) === -1) {
                    hasDates.push(currentDate.toLocaleString('ru', dateYearOptions))
                    dateArray.push(new Date(currentDate))
                }
                currentDate = currentDate.addDays(1)
            }
        }
        console.log('days', dateArray)
        return dateArray;
    }


    const updateData = (params) => {
        EventsService.GetList({filter: {client_id: currentDepartment}}).then((res) => {
            let arr = []
            console.log('events', res.items)
            // res.items.map((el) => {
            //     if(new Date(el.date).getMonth() === date.getMonth() && new Date(el.date).getFullYear() === date.getFullYear()){
            //         arr.push(el)
            //     }
            // })
            setEvents(res.items)
            setLoading(false)


        })
        ArtistService.GetList(params, '').then((response, h) => {

            // if (response.items) {
            setArtists(response.items)

        })
        CashService.GetList({client_id: currentDepartment, limit: 10000}).then((res) => {
            console.log('receipt', res.items)
            setReceipt(res.items)
            setLoading(false)
            setFirstSectionVIew('bar')
        })
    }


    useEffect(() => {

        setLoading(true)
        dispatch(setTitle(''))
        // dispatch()
        dispatch(setCreateButton(false))
        updateData()

    }, [currentDepartment, date]);


    const isSameClient = (receiptItem) => {
        return currentDepartment === null || currentDepartment === undefined || currentDepartment === '' ||
            receiptItem.client_id === null ||
            receiptItem.client_id === undefined ||
            Number(receiptItem.client_id) === Number(currentDepartment)
    }

    const ticketAmount = (event) => {
        let am = 0
        if (receipt) {
            receipt.filter((r) => isSameClient(r) && r.event_id === event.id && !r.is_cost).map((r) => {
                am += r.amount
            })
        }
        console.log('ticket amount = ', am)
        return am
    }
    const ticketAmountBlack = (event) => {
        let am = 0
        if (receipt) {
            receipt.filter((r) => isSameClient(r) && r.event_id === event.id && !r.is_cost && r.type === 'rub').map((r) => {
                am += r.amount
            })
        }
        return am
    }

    const rao = (event) => {
        return ticketAmount(event) / 100 * 5
    }

    const fee = (event) => {
        return (ticketAmount(event) - ticketAmountBlack(event)) / 100 * 6
    }

    const eventFeeAmount = (event) => {
        if (event.artist_fee_correct) {
            return event.artist_fee_correct
        }
        if (event.artist_fee_type === 2) {
            const fee = event.artist_fee || 0;
            return ticketAmount(event) / 100 * fee
        } else {
            return event.artist_fee || 0
        }
    }


    function isInt(value) {
        if (isNaN(value)) {
            return false;
        }
        var x = parseFloat(value);
        return (x | 0) === x;
    }

    const dohod = (event, type = false) => {

        let d = 0

        // Handle canceled events
        if (event.is_canceled && ((dataType === 'dohod' && type === false) || type === 'dohod')) {
            return (event.canceled_amount || 0) * -1
        }

        if ((dataType === 'dohod' && type === false) || type === 'dohod') {
            // Handle null/undefined values as 0 to prevent calculation errors
            const raiderB = event.raider_b || 0;
            const raiderT = event.raider_t || 0;
            const sound = event.sound || 0;
            const rao = event.rao || 0;
            const advFact = event.adv_fact || 0;
            
            d = ticketAmount(event) - eventFeeAmount(event) - raiderB - raiderT - fee(event) - sound - rao - advFact
        }

        if ((dataType === 'rest' && type === false) || type === 'rest') {
            d = event.restaurant || 0
        }

        if ((dataType === 'tickets' && type === false) || type === 'tickets') {
            d = event.ticket_sale || 0
        }


        if (typeof d === 'number' && !isNaN(d)) {
            return d
        } else return 0;
    }


    const updateFullData = () => {
        let dataLabels = []
        let chartDatasets = []
        let chartDatasetsSecond = []

        let firstEvents = []
        let secondEvents = []

        if (firstDate.length === 2 && firstDate[0] && events) {

            let dates = getDates(firstDate[0], firstDate[1])


            dates.map((date, k) => {

                let month = date.getMonth()

                if (rangeType === 'days') {
                    dataLabels.push([date.toLocaleString("ru", dateOptions)])
                }

                if (rangeType === 'month') {
                    dataLabels.push([date.toLocaleString("ru", dateMonthOptions)])
                }

                if (rangeType === 'year') {
                    dataLabels.push([date.toLocaleString("ru", dateYearOptions)])
                }

                let dateDohod = 0
                let filterEvents = events.filter((event) => {

                    let d = new Date(event.date)

                    if (rangeType === 'days') {
                        if (d.getDate() === date.getDate() && d.getMonth() === date.getMonth() && d.getFullYear() === date.getFullYear()) {

                            if (!currentArtist) {
                                return true
                            }

                            if ((currentArtist && currentArtist == event.artist_id) || !currentArtist) {
                                return true
                            }
                        }
                    }

                    if (rangeType === 'month') {
                        if (d.getMonth() === date.getMonth() && d.getFullYear() === date.getFullYear()) {

                            if (!currentArtist) {
                                return true
                            }

                            if ((currentArtist && currentArtist === event.artist_id) || !currentArtist) {
                                return true
                            }
                        }
                    }
                    if (rangeType === 'year') {
                        if (d.getMonth() === date.getMonth() && d.getFullYear() === date.getFullYear()) {


                            if (!currentArtist) {
                                return true
                            }

                            if ((currentArtist && currentArtist == event.artist_id) || !currentArtist) {
                                console.log('yes', d)
                                console.log('yes', date)
                                return true
                            }
                        }
                    }
                });


                filterEvents.map((event) => {


                    let ds = chartDatasets.find((dataset) => dataset.event_id === event.id)
                    if (!ds) {
                        chartDatasets.push({
                            type: firstSectionView,
                            label: event.name + ' (' + new Date(event.date).toLocaleDateString() + ')',
                            event_id: event.id,
                            // backgroundColor: '#7dc006',
                            data: [...Array(k), dohod(event)],
                            // borderColor: 'white',
                            // borderWidth: 2
                        })
                    } else {
                        ds.data.push(dohod(event))
                    }
                    dateDohod += dohod(event)
                    firstEvents.push(event)
                })

                console.log(chartDatasets)

                // chartDatasets.push(dateDohod)

            })


        }


        let dataSets = chartData.datasets
        setFirstEvents(firstEvents)
        // setSecondEvents(secondEvents)
        // console.log(dataSets)


        setChartData({
            ...chartData,
            labels: dataLabels,
            datasets: chartDatasets
        })

    }

    useEffect(() => {
        let data = {
            labels: firstEvents.map((event) => event.name),
            datasets: [
                {
                    data: firstEvents.map((event) => {
                        return dohod(event)
                    })
                }
            ]
        }

        let daysData = {
            labels: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
            datasets: [
                {
                    data: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].map((i, DayKey) => {
                        let d = 0
                        firstEvents.map((event) => {
                            if (new Date(event.date).getDay() === DayKey) {
                                d += dohod(event)
                            }
                        })
                        return d
                    })
                }
            ]
        }

        let monthData = {
            labels: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            datasets: [
                {
                    data: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'].map((i, DayKey) => {
                        let d = 0
                        firstEvents.map((event) => {
                            if (new Date(event.date).getMonth() === DayKey) {
                                d += dohod(event)
                            }
                        })
                        return d
                    })
                }
            ]
        }

        let daysRestData = {
            labels: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
            datasets: [
                {
                    data: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].map((i, DayKey) => {
                        let d = 0
                        firstEvents.map((event) => {
                            if (new Date(event.date).getDay() === DayKey) {
                                d += dohod(event, 'rest')
                            }
                        })
                        return d
                    })
                }
            ]
        }

        let monthRestData = {
            labels: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            datasets: [
                {
                    data: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'].map((i, DayKey) => {
                        let d = 0
                        firstEvents.map((event) => {
                            if (new Date(event.date).getMonth() === DayKey) {
                                d += dohod(event, 'rest')
                            }
                        })
                        return d
                    })
                }
            ]
        }
        setMonthData(monthData)
        setMonthRestData(monthRestData)
        setDaysData(daysData)
        setDaysRestData(daysRestData)
        setDohodData(data)

    }, [firstEvents])

    useEffect(() => {
        updateFullData()
    }, [firstDate, currentArtist, dataType, rangeType, firstSectionView]);


    const handleScroll = (e) => {
        // if(!loading) {
        // localStorage.setItem('analyz_scroll', window.pageYOffset)
        // }
    }

    useEffect(() => {
        // alert(localStorage.getItem('events_scroll'))
        if (localStorage.getItem('analyz_scroll')) {
            window.scrollTo({top: parseInt(localStorage.getItem('analyz_scroll')), behavior: "smooth"});
        }
        updateFullData()
    }, [events]);


    useEffect(() => {

        window.addEventListener('scroll', handleScroll, true);
        // Remove listener when component unmounts
        // window.removeEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll, true);
        }
    }, [])

    const getRazClasses = (k) => {
        if (chartData.datasets[1].data[k] - chartData.datasets[0].data[k] > 0) {
            return 'r-plus';
        } else {
            return 'r-minus';
        }
    }


    const [chartData, setChartData] = useState({
        labels: labels,
        datasets: []
    });

    const [lightOptions] = useState({
        maintainAspectRatio: false,
        aspectRatio: .6,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    });

    const [pieOptions] = useState({
        // options: {
        //     plugins: {
        //         datalabels: {
        //             display: true,
        //             color: '#fff',
        //         }
        //     }
        // },
        plugins: {
            // ChartDataLabels,
            datalabels: {
                display: true,
                formatter: (value, ctx) => {

                    let sum = 0;
                    let dataArr = ctx.chart.data.datasets[0].data;
                    dataArr.map(data => {
                        sum += data;
                    });
                    let percentage = (value*100 / sum).toFixed(2);
                    if(percentage > 0) {
                        return percentage + '%';
                    } else {
                        return '';
                    }
                },
                color: '#fff',
            },
            legend: {
                labels: {
                    usePointStyle: true
                }
            }
        }
    });

    const getCountTickets = (events) => {
        return events.reduce((partialSum, a) => partialSum + a.ticket_sale, 0)
    }

    const getRestaurant = (events) => {
        return events.reduce((partialSum, a) => partialSum + a.restaurant, 0)
    }

    const getDohod = (events) => {
        return events.reduce((partialSum, a) => partialSum + dohod(a, 'dohod'), 0)
    }

    return (
        <>

            <div className="d-flex align-items-center justify-content-between p-t-10">
                <h1>{'Аналитика'}</h1>

                <div>
                    <Dropdown placeholder={'Выберите артиста'} options={artists.map((artist) => {
                        return {
                            value: artist.id,
                            label: artist.name
                        }
                    })} filter={true} value={currentArtist} onChange={(e) => {

                        let dateFrom = new Date()
                        let dateTo = new Date(new Date().setFullYear(2020))
                        let ev = events.filter((event) => event.artist_id === e.value)

                        ev.map((el) => {

                            if (new Date(el.date).getTime() < dateFrom.getTime()) {

                                dateFrom = new Date(Date.parse(el.date));
                            }
                            if (new Date(el.date).getTime() > dateTo.getTime()) {

                                dateTo = new Date(Date.parse(el.date));
                            }
                        })
                        if (e.value) {
                            setNeedRange(false)
                        } else {
                            setNeedRange(true)
                        }
                        console.log('dateTo', dateTo)
                        setFirstDate([dateFrom, dateTo])
                        setSecondDate([dateFrom, dateTo])
                        setCurrentArtist(e.value)
                    }}
                              showClear={true}/>
                </div>


            </div>

            <div className="card analytic-filter">
                <div className="card-body">
                    <div className={'row'}>
                        <div className={'col-5'}>
                            <div>Период</div>

                            <div className={'d-flex justify-content-between gap-3'}>
                                <Calendar value={firstDate} showOtherMonths={false} hideOnDateTimeSelect={true}
                                          onChange={(e) => setFirstDate(e.value)} selectionMode={'range'}
                                          numberOfMonths={3}
                                          showIcon={true}/>


                            </div>
                        </div>

                    </div>


                    <div className="row mt-5">
                        <div className="col-5">

                            <h3>Сводка по всем мероприятиям</h3>

                            <div className="d-flex gap-5">

                                <div>
                                    <small>Прибыль</small>
                                    <h3>{formater.amountFormat(firstEvents.reduce((partialSum, a) => partialSum + dohod(a, 'dohod'), 0))}</h3>
                                </div>

                                <div>
                                    <small>Билеты</small>
                                    <h3>{firstEvents.reduce((partialSum, a) => partialSum + a.ticket_sale, 0)}</h3>

                                </div>

                                <div>
                                    <small>Ресторан</small>
                                    <h3>{formater.amountFormat(firstEvents.reduce((partialSum, a) => partialSum + a.restaurant, 0))}</h3>
                                </div>

                            </div>

                        </div>
                        <div className="col-5 offset-2">
                            <div className="d-flex gap-5">


                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="card">
                <div className="card-body">

                    <DataTable sortMode="multiple" value={firstEvents.map((event) => {
                        return {
                            name: event.name + ', ' + new Date(event.date).toLocaleDateString(),
                            dohod: formater.amountFormat(dohod(event, 'dohod')),
                            dohod_key: dohod(event, 'dohod'),
                            tickets: dohod(event, 'tickets'),
                            rest: formater.amountFormat(dohod(event, 'rest')),
                            rest_key: dohod(event, 'rest'),
                            day: formater.dayShortName(new Date(event.date).getDay()),
                            day_key: new Date(event.date).getDay() !== 0 ? new Date(event.date).getDay() : 7
                        }
                    })}>
                        <Column field="name" header="Мероприятие" style={{width: '20%'}}></Column>
                        <Column field="dohod" header="Прибыль"  sortField={'dohod_key'} sortable style={{width: '20%'}}></Column>
                        <Column field="tickets" header="Билеты" sortable style={{width: '20%'}}></Column>
                        <Column field="rest" header="Ресторан"  sortField={'rest_key'} sortable style={{width: '20%'}}></Column>
                        <Column field="day" header="День недели" sortField={'day_key'} sortable
                                style={{width: '20%'}}></Column>
                    </DataTable>
                </div>
            </div>

            {dohodData &&
                <div class={''}>
                    <div className="">
                        <h2>Прибыль</h2>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="card">
                                    <div className="card-body">
                                        <h3>Месяцы</h3>

                                        <PrimeChart type="pie" data={monthData} options={pieOptions}
                                               className="w-full md:w-30rem"/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card">
                                    <div className="card-body">
                                        <h3>Дни недели</h3>

                                        <PrimeChart type="pie" data={daysData} options={pieOptions}
                                               className="w-full md:w-30rem"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {dohodData &&
                <div class={''}>
                    <div className="">
                        <h2>Ресторан</h2>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="card">
                                    <div className="card-body">
                                        <h3>Месяцы</h3>

                                        <PrimeChart type="pie" data={monthRestData} options={pieOptions}
                                               className="w-full md:w-30rem"/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card">
                                    <div className="card-body">
                                        <h3>Дни недели</h3>

                                        <PrimeChart type="pie" data={daysRestData} options={pieOptions}
                                               className="w-full md:w-30rem"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }


            <div className="card">
                <div className="card-body">

                    {loading && <Loader/>}

                    <div className={'d-flex align-items-center justify-content-between'}>
                        <SelectButton optionLabel="name" optionValue="value" options={[
                            {name: 'Дни', value: 'days'},
                            {name: 'Месяцы', value: 'month'},
                            {name: 'Года', value: 'year'},
                        ]} value={rangeType} onChange={(e) => {

                            setRangeType(e.value)
                        }
                        }/>

                        <SelectButton className={'flex-shrink-0'} optionLabel="name" optionValue="value"
                                      options={[
                                          {name: 'Бар', value: 'bar'},
                                          {name: 'Линия', value: 'line'},
                                      ]} value={firstSectionView} onChange={(e) => {

                            setFirstSectionVIew(e.value)
                        }
                        }/>

                        <SelectButton optionLabel="name" optionValue="value" options={[
                            {name: 'Прибыль', value: 'dohod'},
                            {name: 'Билеты', value: 'tickets'},
                            {name: 'Ресторан', value: 'rest'},
                        ]} value={dataType} onChange={(e) => {

                            setDataType(e.value)
                        }
                        }/>
                    </div>

                    <PrimeChart type="bar" data={chartData} options={lightOptions}/>


                </div>
            </div>


        </>
    )
}

export default AnaliticFull